import React from 'react';
import { motion } from 'framer-motion';

export default function FeatureCard({ title, desc, image }) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 10 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.4 }}
      className="overflow-hidden rounded-2xl border bg-white shadow-sm"
    >
      <div className="aspect-[4/3] w-full bg-slate-200/60">
        <img src={image} alt="" className="h-full w-full object-cover object-top" />
      </div>
      <div className="p-5">
        <h3 className="text-lg font-semibold">{title}</h3>
        <p className="mt-1 text-sm text-slate-600">{desc}</p>
      </div>
    </motion.div>
  );
}
